import { render, staticRenderFns } from "./Study.vue?vue&type=template&id=32677c5b&scoped=true&"
import script from "./Study.vue?vue&type=script&lang=js&"
export * from "./Study.vue?vue&type=script&lang=js&"
import style0 from "./Study.vue?vue&type=style&index=0&id=32677c5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32677c5b",
  null
  
)

export default component.exports